// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");

// Función del router
const WorkflowNavigationButtons = (params) => {
  
  useEffect(() => {                
    if(localStorage.getItem("installationConfigurationMode") !== null){
      document.getElementById("botonContinuar").innerHTML="Guardar configuración"                
      document.getElementById("botonContinuar").className = document.getElementById("botonContinuar").className.replaceAll(" hidden", "")
      document.getElementById("botonSaltar").className = document.getElementById("botonSaltar").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonAtras").className = document.getElementById("botonAtras").className.replaceAll(" hidden", "") + " hidden"
    }
    else{
      if(params.step === "MESSAGING"){
        document.getElementById("botonContinuar").innerHTML = "Finalizar"          
      }
      else if(params.step.includes("GENERAL_INFO")){        
        document.getElementById("botonAtras").className = document.getElementById("botonAtras").className.replaceAll(" hidden", "") + " hidden"
      }
    }
        
    if( 
      (params.step.includes("GENERAL_INFO")) ||
      (params.step === "METEO") ||
      (params.step === "MESSAGING") ||
      (params.step === "INSTALLATION_ELEMENTS") ||      
      (params.step === "DEVICES")
    ){      
      document.getElementById("botonEliminarConfiguracion").className = document.getElementById("botonEliminarConfiguracion").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonSaltar").className = document.getElementById("botonSaltar").className.replaceAll(" hidden", "") + " hidden"
    }
    else{
      if(localStorage.getItem("installationConfigurationMode") === null){
        document.getElementById("botonSaltar").className = document.getElementById("botonSaltar").className.replaceAll(" hidden", "")
      }
    }

  });   

  function guardar(){
    
    if(localStorage.getItem("installationConfigurationMode") !== null){
      localStorage.setItem("forceUpdate", "true")
    }

    params.navegar("continuar")

  }

  function eliminar(){

    if(localStorage.getItem("installationConfigurationMode") !== null){
      localStorage.setItem("forceUpdate", "true")
    }

    initialConfigCommonJS.eliminarConfiguracion()
  }

  return (
    <ul className="actions">
      <li><button id="botonContinuar" className="button primary" onClick={() => guardar()}>Continuar</button></li>      
      <li><button id="botonAtras" className="button tertiary" onClick={() => params.navegar("volver")}>Volver</button></li>     
      <li><button id="botonSaltar" className="button secondary hidden" onClick={() => initialConfigCommonJS.saltarPaso()}>Configurar más tarde</button></li>      
      <li><button id="botonEliminarConfiguracion" className="button secondary delete hidden" onClick={() => eliminar()}>Eliminar configuración</button></li>    
    </ul>
  )
}

export default WorkflowNavigationButtons